import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
}), 'HeightOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HeightOutlined.js
// module id = 4111
// module chunks = 2